export default __webpack_public_path__ + "static/media/Chat-Numbers-System-01.539b3f9a.svg";